import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function NewCrest() {
  const dateTexts = ['1800年'];
  const title = 'S.E.A.の新たなスタートと新しい紋章';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2022/01/crest.jpg'
  const description = (
    <>
      {'19世紀の幕開けを祝い、S.E.A.は紋章を新たに作成する。'}
      {'以降のS.E.A.は、世界中から歴史的に価値のある美術品や財宝を集め調査・解明することに焦点を当てるようになる。'}
    </>
  );

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      important
    />
  );
}

export default NewCrest;
